import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Card, Statistic, Space, Tooltip } from "antd";
import { TrophyOutlined } from "@ant-design/icons";
import { ProfileContext } from "Common/hooks/context/ProfileContext";

const LearningStats = ({ darkMode, learningStates }) => {
  const { isProfileComplete } = useContext(ProfileContext);
  const isBlocked = !isProfileComplete;

  const theme = {
    background: darkMode ? "#1f1f1f" : "#fff",
    border: darkMode ? "#303030" : "#f0f0f0",
    text: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined,
    completed: darkMode ? "#73d13d" : "#52c41a",
    current: darkMode ? "#1890ff" : "#40a9ff",
    tasks: darkMode ? "#ffec3d" : "#faad14"
  };

  return (
    <Tooltip title={isBlocked ? "Complete your profile to view stats" : ""}>
      <Card
        title={
          <span style={{ color: theme.text }}>
            <TrophyOutlined style={{ marginRight: 8 }} /> Learning Stats
          </span>
        }
        style={{
          borderRadius: 8,
          backgroundColor: theme.background,
          borderColor: theme.border,
        }}
        bodyStyle={{ padding: '12px' }}
      >
        <Space size={16} direction="vertical" style={{ width: '100%' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
            <Statistic
              title={<span style={{ color: theme.completed }}>Completed</span>}
              value={learningStates.coursesCompleted}
              valueStyle={{ color: theme.completed }}
            />
            <Statistic
              title={<span style={{ color: theme.current }}>Current</span>}
              value={learningStates.currentCourses}
              valueStyle={{ color: theme.current }}
            />
          </div>
          
          <div style={{ 
            height: '1px', 
            backgroundColor: theme.border,
            margin: '0 -12px'
          }} />
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
            <Statistic
              title={<span style={{ color: theme.tasks }}>Submitted</span>}
              value={learningStates.submittedTasksCount}
              valueStyle={{ color: theme.tasks }}
            />
            <Statistic
              title={<span style={{ color: theme.tasks }}>Avg Score</span>}
              value={learningStates.scores}
              valueStyle={{ color: theme.tasks }}
            />
          </div>
        </Space>
      </Card>
    </Tooltip>
  );
};

LearningStats.propTypes = {
  darkMode: PropTypes.bool.isRequired,
  learningStates: PropTypes.shape({
    coursesCompleted: PropTypes.number.isRequired,
    currentCourses: PropTypes.number.isRequired,
    submittedTasksCount: PropTypes.number.isRequired,
    scores: PropTypes.number.isRequired,
  }).isRequired,
};

export default LearningStats;